<template>
  <div>
    <b-row align-h="between" class="mb-3">
      <b-col cols="6">
        <b-button-group size="md">
          <b-button class="mr-2" variant="outline-success" @click="add" v-if="allow('A')">
            <b-icon-plus></b-icon-plus>
            {{$l('btn_addLabel') || '新增标签'}}
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="6">
        <b-form>
          <b-input-group>
            <b-form-input type="search" @keyup.enter="query" v-model="form.prjTagName" placeholder="Search here..." />
            <b-input-group-append>
              <b-button-group>
                <b-button variant="primary" class="my-2 my-sm-0" @click="query">
                  <i class="fa fa-search"></i>
                </b-button>
                <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 400px;">
                    <h6>{{$l('tips_filterBy') || 'Filter by'}}</h6>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <el-input
                          style="width:100%;"
                          size="small"
                          clearable
                          v-model="form.prjTagOwnerName"
                          :placeholder="$l('tips_labelOwner') || '标签所属人'"
                        ></el-input>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mt-1 mb-2">
                      <b-col md="12" lg="12">
                        <b-form-group :label="$l('tips_labelType') || '标签类型'">
                          <el-select size="small" clearable filterable style="width: 100%" v-model="form.prjTagType">
                            <el-option value="C" label="公共标签"></el-option>
                            <el-option value="P" label="私有标签"></el-option>
                          </el-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('tips_status') || '状态'">
                          <b-form-checkbox-group
                            style="width:100%;"
                            id="checkbox-group-2"
                            v-model="form.prjTagStatusList"
                          >
                            <b-form-checkbox value="Y">{{$l('tips_effective' || '有效')}}</b-form-checkbox>
                            <b-form-checkbox value="N">{{$l('tips_invalid' || '无效')}}</b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col style="text-align:center;">
                        <b-button
                          block
                          variant="primary"
                          @click="query"
                        >{{$l('btn_search' || 'Search')}}</b-button>
                        <b-button
                          block
                          variant="outline-primary"
                          @click="reset"
                        >{{$l('btn_reset' || 'Reset')}}</b-button>
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        prjTagType: "",
        prjTagOwnerName: "",
        prjTagName: "",
        prjTagStatusList: ["Y"],
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    reset() {
      this.form = {
        prjTagType: "",
        prjTagOwnerName: "",
        prjTagName: "",
        prjTagStatusList: ["Y"],
      };
      this.query();
    },
    add() {
      this.$emit("add");
    },
  },
  mounted() {
    this.query();
  },
  activated() {
    this.query();
  }
};
</script>
